import Cookies from 'universal-cookie';

import { getState, dispatch as globalDispatch, select } from '@swf/core/store';
import CookieNames from '@swf/core/types/Cookies';

const cookies = new Cookies();

export const clearCookies = (state = getState()) => {
  const domain = select.location.getCookieDomain(state);
  [
    CookieNames.BRAND,
    CookieNames.COUNTRY,
    CookieNames.LICENSE,
    CookieNames.LIMITED_MODE,
    CookieNames.SIGNATURE,
    CookieNames.SITE,
    CookieNames.TOKEN,
    CookieNames.WEB_ID
  ].forEach((name) => cookies.remove(name, { domain, path: '/' }));
};

export const clearSession = (dispatch = globalDispatch) => {
  dispatch.session.clear();
  dispatch.account.clear();
  dispatch.rewardsLegacy.reset();
};

export const clearSessionSummary = () => {
  globalDispatch.localSettings.set({ sessionSummary: undefined });
};

export const clearRemainigInactivitySeconds = () => {
  globalDispatch.localSettings.set({ remainingInactivitySeconds: undefined });
};

export const clearAll = () => {
  clearSession();
  clearCookies();
  clearSessionSummary();
  clearRemainigInactivitySeconds();
};
